import React, { FC, Fragment, ReactElement, RefObject, useRef } from 'react'
import { IconButtonWithLabel } from '../../../Atoms/IconButtonWithLabel/IconButtonWithLabel'
import { EMPTY_STRING } from '../../../../../NonReact/constants/Common'
import IconButton, { IconButtonType } from '../../../../../React/Common/Components/IconButton'
import { IconName } from '../../../../../React/Common/Components/Icon'
import { SidebarMenuItems } from '../../../../../NonReact/constants/ReactRouter/Header/Constants'
import { SubMenuItem } from '../../../../../NonReact/common/Types/Types'

type Props = {
    sidebarMenuItem: SubMenuItem
    isSidebarExpanded: boolean
    favourites?: SidebarMenuItems[]
    handleOnClickFavourite: (sidebarMenuItem: SidebarMenuItems) => void
}

export const SideMenuEntry: FC<Props> = ({
    isSidebarExpanded,
    handleOnClickFavourite,
    favourites,
    sidebarMenuItem: { enabled, icon, id, title, handleClick, active }
}: Props): ReactElement => {
    const infoPopperRef: RefObject<HTMLDivElement> = useRef(null)

    return enabled ? (
        <div ref={infoPopperRef} key={icon} className='sidebar-menu-item'>
            <IconButtonWithLabel
                id={`sidebar-button-${id.toLowerCase()}`}
                label={title}
                onClick={(): void => handleClick(false)}
                onMiddleClick={(): void => handleClick(true)}
                className={`sidebar-menu-item-button ${active ? 'smi-active' : EMPTY_STRING}`}
                iconName={icon}
                tooltip={isSidebarExpanded ? undefined : title}
                popperClassNames='smi-button-tooltip'
                topRightAdornment={
                    <IconButton
                        customClassName='sidebar-favourite-button'
                        iconName={favourites?.includes(id) ? IconName.FAVOURITE : IconName.FAVOURITE_OUTLINED}
                        type={IconButtonType.BUTTON}
                        onClick={(): void => handleOnClickFavourite(id)}
                    />
                }
            />
        </div>
    ) : (
        <Fragment key={icon} />
    )
}
